import { createContext, Dispatch, FC, PropsWithChildren, Reducer, useEffect, useReducer } from 'react';

import { getSessionStorage } from '../../../utils/sessionStorage';

export interface HeaderState {
  blogIndexQueryString: string;
  isShowingSystemAlert: boolean;
}

// Action types
interface UpdateBlogIndexQueryStringAction {
  payload: { blogIndexQueryString: string };
  type: 'updateBlogIndexQueryString';
}
interface UpdateIsShowingSystemAlertAction {
  payload: { isShowingSystemAlert: boolean };
  type: 'updateIsShowingSystemAlert';
}

type HeaderContextAction =
  | UpdateBlogIndexQueryStringAction
  | UpdateIsShowingSystemAlertAction;
export type HeaderDispatch = Dispatch<HeaderContextAction>;

// Local Variables
const initialState: HeaderState = {
  blogIndexQueryString: '',
  isShowingSystemAlert: false,
};

export const HeaderStateContext = createContext(initialState);
export const HeaderDispatchContext
  = createContext<HeaderDispatch>(undefined as unknown as HeaderDispatch);

HeaderStateContext.displayName = 'HeaderState';
HeaderDispatchContext.displayName = 'HeaderDispatch';

const reducer: Reducer<HeaderState, HeaderContextAction> = (state, action) => {
  switch (action.type) {
    case 'updateBlogIndexQueryString': {
      return {
        ...state,
        blogIndexQueryString: action.payload.blogIndexQueryString,
      };
    }
    case 'updateIsShowingSystemAlert': {
      return {
        ...state,
        isShowingSystemAlert: action.payload.isShowingSystemAlert,
      };
    }
    default:
      throw new Error();
  }
};

const HeaderContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    dispatch({
      payload: {
        blogIndexQueryString: getSessionStorage('blogIndexQueryParams') ?? '',
      },
      type: 'updateBlogIndexQueryString',
    });
  }, []);

  return (
    <HeaderStateContext.Provider value={state}>
      <HeaderDispatchContext.Provider value={dispatch}>
        {children}
      </HeaderDispatchContext.Provider>
    </HeaderStateContext.Provider>
  );
};

export default HeaderContextProvider;
